module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/ForgedinFire.ce730e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/ForgedinFire.jpg
// module id = bWts
// module chunks = 0